import { render } from "./SingleUser.vue?vue&type=template&id=5d534a5a"
import script from "./SingleUser.vue?vue&type=script&lang=js"
export * from "./SingleUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__